module.exports = __webpack_public_path__ + "static/img/cab-celestion.ec0b7e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/cab-celestion.png
// module id = hKS1
// module chunks = 12